const stats = [
    { value: "2,500+", label: "Instructeurs Actifs" },
    { value: "€2.4M+", label: "Revenus Générés" },
    { value: "50K+", label: "Étudiants Formés" },
    { value: "15+", label: "Pays Africains" },
];

const StatsSection = () => {
    return (
        <section className="py-20 bg-background text-white relative overflow-hidden">
            {/* Abstract African Pattern Overlay */}
            <div className="absolute inset-0 opacity-10 pointer-events-none geometric-pattern" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {stats.map((stat, index) => (
                        <div key={index} className="text-center animate-fade-up" style={{ animationDelay: `${index * 0.1}s` }}>
                            <div className="font-display text-african-accent text-4xl sm:text-5xl lg:text-6xl font-bold mb-2">
                                {stat.value}
                            </div>
                            <div className="text-muted-foreground font-medium uppercase tracking-wider text-sm">
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsSection;
